<div class="user-list-item" (click)="userClicked()">
  <ion-avatar slot="start">
    <img *ngIf="user && user.profilePicture" [src]="user?.profilePicture || null" [alt]="user?.firstName.substring(0,2)">
    <text-avatar *ngIf="user && !user.profilePicture" [text]="user.firstName || ''"></text-avatar>
  </ion-avatar>
  <ion-label>
    <h2>{{ user?.firstName }} {{ user?.lastName }}</h2>
    <p *ngIf="user && detail">{{user[detail]}}</p>
  </ion-label>

  <!-- Status -->
  <p class="clientStatus" [ngClass]="getClientStatus(user.status)" *ngIf="user?.status && showStatus">{{user.status}}</p>

  <!-- Controls -->
  <ion-checkbox color="primary" *ngIf="control === 'select'" [(ngModel)]="isSelected" (ionChange)="userSelected()" stop-propagation></ion-checkbox>
  <ion-button size="small" color="danger" slot="end" *ngIf="control === 'remove'" (click)="userRemoved($event)">
    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
  </ion-button>
</div>
